__turbopack_context__.v({
  "link": "CrkOyq_link",
});
